import Button from "./UI/Button";

interface PopupModalProps {
  onClose: () => void;
  children: React.ReactNode;
}

const PopupModal: React.FC<PopupModalProps> = ({ onClose, children }) => (
  
  
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div style={{ maxHeight: '80vh', overflowY: 'auto', padding: '1rem' }} className="bg-white rounded-xl shadow-xl p-6 w-[90%] max-w-2xl relative">
      <Button
        onClick={onClose}
        className="absolute top-2 left-2 text-gray-500 hover:text-black text-xl"
      >
        ✖️
      </Button>
      {children}
    </div>
  </div>
  
);
export default PopupModal;